module.exports = __webpack_public_path__ + "static/img/SD.f65980dd.png";